module.exports = __webpack_public_path__ + "6927e8ed5a9c5a232b9478a821ac3083.png";